import CustomCard from "components/Atoms/CustomCard"
import StyledLink from "components/Atoms/StyledLink"
import Toggle from "components/Atoms/Toggle"
import Error from "components/Common/Error"
import TablePagination from "components/Molecules/TablePagination"
import NewResourceButton from "components/Organisms/AddResourceButton"
import { Subtitle, Title } from "components/Organisms/table/DataCell"
import SerialColumn from "components/Organisms/table/SerialColumn"
import CustomReactTable from "components/Templates/CustomReactTable"
import ModuleHeader, { Description } from "components/Templates/ModuleHeader"
import {
  useCreateUpdateNotificationTemplateNewMutation,
  useNotificationTemplateListNewQuery,
} from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import React from "react"
import AppToaster from "utils/AppToaster"

const COLUMNS = [
  SerialColumn,
  {
    width: 100,
    accessor: "isActive",
    Header: "Active",
    Cell({ value, original }) {
      const [mutate, { loading }] =
        useCreateUpdateNotificationTemplateNewMutation({
          onCompleted({ addUpdateNotificationTemplateV1 }) {
            const data = addUpdateNotificationTemplateV1?.template
            AppToaster.show({
              intent: "success",
              message: `Template ${data.name ?? data?.title} is ${
                data.isActive ? "active" : "inactive"
              }`,
            })
          },
          onError() {
            AppToaster.show({
              message: "Unable to update the template",
              intent: "danger",
            })
          },
        })

      return (
        <Toggle
          onChange={e =>
            mutate({
              variables: {
                id: original.id,
                isActive: e.currentTarget.checked,
              },
            })
          }
          disabled={loading}
          large
          className="mb-0"
          intent="success"
          checked={value}
        />
      )
    },
  },
  {
    width: 400,
    Header: "Name",
    accessor: "name",
    Cell({ value, original }) {
      return (
        <>
          <StyledLink
            to={`/d/registration/notification-templates/${original.id}`}
          >
            {value}
          </StyledLink>
        </>
      )
    },
  },
  {
    width: 300,
    Header: "Provider",
    accessor: "provider",
    Cell({ value }) {
      return (
        <div>
          <Title>{value.name}</Title>
          <Subtitle>{value.kind}</Subtitle>
        </div>
      )
    },
  },
  {
    Header: "Subject",
    accessor: "title",
  },
]
const NewNotificationTemplates = () => {
  const [{ search, page }, setFilter] = useSearchFilter()
  const { data, loading, error } = useNotificationTemplateListNewQuery({
    variables: {
      query: search,
      first: 10,
      skip: page * 10,
    },
  })

  if (error) return <Error message={error?.name} />

  return (
    <CustomCard className="p-0 m-3">
      <ModuleHeader
        borderBottom="none"
        query={search ?? ""}
        onQueryChange={search => {
          setFilter(prev => ({
            ...prev,
            search,
            page: 0,
          }))
        }}
        white
        className="p-3"
        header={
          <Description icon="notifications" title="Notification Templates" />
        }
      >
        <TablePagination
          className="mr-3"
          page={page}
          onPageChange={page => {
            setFilter(prev => ({
              ...prev,
              page,
            }))
          }}
        />

        <NewResourceButton text={"Template"} module="notification-templates" />
      </ModuleHeader>
      <CustomReactTable
        leftAlign={true}
        loading={loading}
        loadingText="Loading Sellable Items"
        pageSize={13}
        data={data?.allV1NotificationTemplates}
        columns={COLUMNS}
      />
    </CustomCard>
  )
}

export default NewNotificationTemplates
